import { render, staticRenderFns } from "./FireCauseCommonPartsOrigin.vue?vue&type=template&id=2441f93e&scoped=true"
import script from "./FireCauseCommonPartsOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseCommonPartsOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseCommonPartsOrigin.vue?vue&type=style&index=0&id=2441f93e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2441f93e",
  null
  
)

export default component.exports